import { HttpError } from 'ra-core';

const FALLBACK_ERROR_MESSAGE =
  'Unexpected error. Please reach out to Moonstar Support.';

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof HttpError && typeof error.body?.message === 'string') {
    return error.body.message;
  }

  return FALLBACK_ERROR_MESSAGE;
};
